export default __webpack_public_path__ + "static/media/Groupe 4467.5509e92d.svg";